module.exports = __webpack_public_path__ + "img/pdf.b7629195.svg";